<template>
  <div class="select-container">
    <label>
      <span :class="{ labelObrigatorio: (campoVazio && required) }">{{ label }}</span>
      <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="!!label && loadingData"></span>
      <i v-if="helpLabel" class="fa fa-question-circle is-size-6 help-tip ml-1" :title="helpLabel"></i>
    </label>
    <Multiselect
      :options="options"
      class="multiselect-econtador"
      :placeholder="placeholder"
      :searchable="true"
      :id="idSelect"
      v-model="selectedOption"
      @select="$emit('valueSelect', selectedOption), this.verificarSeInputEstaVazio()"
      @clear="$emit('clear', selectedOption), this.verificarSeInputEstaVazio()"
      :class="{ inValida: (campoVazio && required), 'select is-loading is-inline-block': this.loadingData, 'cursor-not-allowed': disabled && !this.loadingData }"
      :canClear="canClear"
      :canDeselect="false"
      ref="multiselect"
      :disabled="disabled"
      :showNoOptions="false"
      :noOptionsText="noOptionsText"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
    />
    <div v-if="required && !disableErrorMessage" class="mensagemDeErro">
      <slot name="erroMessage" v-if="campoVazio">
        <span v-if="label != null" class="campo-obrigatório"
          >{{ label }} é obrigatório.</span
        >
        <span v-else class="campo-obrigatório">Campo obrigatório.</span>
      </slot>
    </div>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
export default {
  name: "TrfSelect",
  components: {
    Multiselect,
  },
  props: {
    hasSelectedOption: { default: false, type: Boolean },
    disableErrorMessage: { type: [Boolean], default: false },
    label: String,
    placeholder: String,
    noOptionsText: String,
    disabled: { default: false, type: Boolean },
    width: String,
    idSelect: String,
    options: {
      type: [Array, Function],
    },
    canClear: { default: false, type: Boolean },
    loadingData: Boolean,
    required: {
      type: [Boolean],
      default: true
    },
    helpLabel: String,
    mensagemCampoObrigatorio: String
  },
  data() {
    return {
      campoVazio: false,
      selectedOption: ""
    };
  },
  methods: {
    selecionar(valor) {
      if (!valor) {
        this.limparSelect()
        this.limparValue()
        return
      }
      const element = this.$refs.multiselect;
      element.select(valor);
      this.selectedOption = valor;
      return valor;
    },
    defaultSelect() {
      if (this.hasSelectedOption && this.options.length > 0) {
        this.selectedOption = this.options[0].value;
      }
    },
    iniciarSelectComValor(value) {
      if (this.options.length > 0 && value !== null) {
        let index = this.options.findIndex((o) => o.value === value);
        this.selectedOption = this.options[index]?.value;
      }
      return this.selectedOption;
    },
    iniciarSelectComValorBuscandoPorLabel(value) {
      if (this.options.length > 0 && value !== null) {
        let index = this.options.findIndex((o) => o.label === value);
        this.selectedOption = this.options[index].value;
      }
      return this.selectedOption;
    },
    limparSelect() {
      this.$refs.multiselect.clear();
    },
    limparValue() {
      if (this.selectedOption == "" || this.selectedOption == null) {
        return true;
      }
    },
    limparValidacao() {
      this.campoVazio = false;
    },
    verificarSeInputEstaVazio() {
      if(!this.required) return false;
      if (this.selectedOption == "" || this.selectedOption == null) {
        return (this.campoVazio = true);
      } else {
        return (this.campoVazio = false);
      }
    },
  },
  created() {
    this.defaultSelect();
  },
};
</script>

<style lang="scss" scoped>
.select-container {
  margin-bottom: 15px;
}
label {
  display: block;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 10px 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.cursor-not-allowed {
  cursor: not-allowed!important;
}
.help-tip {
  vertical-align: text-bottom;
}
</style>
